import React from 'react';
import { LOGO_URL } from './constants';
export function Header() {
  return <header className="sticky top-0 z-40 border-b border-navy/10 bg-cream/90 backdrop-blur-md" data-id="element-117">
      <div className="mx-auto flex max-w-5xl items-center justify-center px-4 py-2.5" data-id="element-118">
        <img src={LOGO_URL} alt="Karito Educa" className="h-10 w-auto sm:h-12" data-id="element-119" />
      </div>
    </header>;
}